// extracted by mini-css-extract-plugin
module.exports = {"localUpload":"localUpload___28Hhz","progressBox":"progressBox___3b7pS"};